import Script from "next/script";
import React from "react";
import { env } from "~/env.mjs";

// // // //

// Pull Google Tag Manager ID from env
// NOTE - the `NEXT_PUBLIC_` prefix must be included or else this env variable won't load in the app
const GOOGLE_TAG_MANAGER_ID = env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

/**
 * GoogleAnalyticsScript
 * Loads Google Analytics in the app
 * Doc: https://nextjs.org/docs/messages/next-script-for-ga
 */
export function GoogleAnalyticsScript() {
    if (!GOOGLE_TAG_MANAGER_ID) {
        return null;
    }

    return (
        <React.Fragment>
            <Script
                async
                src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_MANAGER_ID}`}
            />
            <Script id="google-analytics" strategy="afterInteractive">
                {`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  
  gtag('config', '${GOOGLE_TAG_MANAGER_ID}');
  `}
            </Script>
        </React.Fragment>
    );
}
